export default __webpack_public_path__ + "static/media/featuredImage.0bf3455b.jpg";